import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Input, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.imputaciones.titulosSeparaciones.edit}
                postUrl={api.imputaciones.titulosSeparaciones.edit}
                buttonTitle={"Editar Título"}
                title={"Editar Título"}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El parámetro ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                buttonIcon={"fa fa-pencil fa-lg"}
                className={"ui-modal-dialog"}
                saveButton={true}
                closeButton={true}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <h5 className="ui-section-label">Datos del parámetro</h5>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <label>Nombre</label>
                                <Input type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/TitulosSeparaciones/Edit.js